export var getClassNames = function getClassNames(defaultClasses, customClass) {
  var classes = [customClass || ''];
  var keys = Object.keys(defaultClasses);
  keys.forEach(function (key) {
    if (defaultClasses[key]) {
      classes.push(key);
    }
  });
  return classes.join(' ').trim();
};